/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionrealist3Inputs */



/**
* | output |
* | --- |
* | "You’re basically comfort in human form. You don’t need fancy parties: with you it’s easy to be real, drink tea in the kitchen, and talk about life without ex..." |
*
* @param {Personalityarchetypedescriptionrealist3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionrealist3 = /** @type {((inputs?: Personalityarchetypedescriptionrealist3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionrealist3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You’re basically comfort in human form. You don’t need fancy parties: with you it’s easy to be real, drink tea in the kitchen, and talk about life without extra drama or judgment.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eres básicamente el confort hecho persona. No necesitas fiestas ostentosas: contigo es fácil ser auténtico, tomar un té en la cocina y hablar de la vida sin dramas ni juicios.")
	return /** @type {LocalizedString} */ ("Ты — синоним комфорта. Тебе не нужны пафосные тусовки: с тобой легко быть собой, пить чай на кухне и обсуждать жизнь без лишней драмы и осуждения.")
});
export { personalityarchetypedescriptionrealist3 as "personalityArchetypeDescriptionRealist" }